export default "__VITE_ASSET__BLyyU_PK__"